/* Windows 95 Contact Form */

class Windows95Contact {
  constructor() {
    this.contactWindow = null;
    this.init();
  }

  init() {
    document.addEventListener('win95-open-contact', () => {
      this.openContactWindow();
    });
  }

  openContactWindow() {
    if (this.contactWindow && document.body.contains(this.contactWindow)) {
      window.Windows95Desktop.bringToFront(this.contactWindow);
      return;
    }

    const contactWindow = document.createElement('div');
    contactWindow.className = 'win95-window active';
    contactWindow.id = 'contact-window';
    contactWindow.style.width = '450px';
    contactWindow.style.maxWidth = '90vw';

    contactWindow.innerHTML = `
      <div class="win95-title-bar">
        <div class="win95-title-text">
          <span>✉️</span>
          Contact Us
        </div>
        <div class="win95-window-controls">
          <button class="win95-btn win95-btn-minimize" aria-label="Minimize"></button>
          <button class="win95-btn win95-btn-close" aria-label="Close"></button>
        </div>
      </div>
      <div class="win95-window-content" style="padding: 16px;">
        <p style="margin-bottom: 16px; font-size: 12px;">
          Enjoying the site or have a question? Shoot me a message!
        </p>
        
        <form id="contact-form" accept-charset="UTF-8">
          <div class="win95-form-group">
            <label class="win95-label" for="contact-name">Name:</label>
            <input 
              type="text" 
              id="contact-name" 
              name="name"
              class="win95-input" 
              required
              style="width: 100%;"
            >
          </div>

          <div class="win95-form-group">
            <label class="win95-label" for="contact-email">Email:</label>
            <input 
              type="email" 
              id="contact-email" 
              name="email"
              class="win95-input" 
              required
              style="width: 100%;"
            >
          </div>

          <div class="win95-form-group">
            <label class="win95-label" for="contact-message">Message:</label>
            <textarea 
              id="contact-message" 
              name="message"
              class="win95-input" 
              rows="6"
              required
              style="width: 100%; resize: vertical; font-family: 'MS Sans Serif', Arial, sans-serif;"
            ></textarea>
          </div>

          <div style="margin-top: 16px; padding-top: 16px; border-top: 2px groove var(--win95-dark-gray);">
            <div style="display: flex; justify-content: flex-end; gap: 8px;">
              <button type="submit" class="win95-button win95-button-primary" id="contact-submit">
                Send Message
              </button>
              <button type="button" class="win95-button" id="contact-cancel">
                Cancel
              </button>
            </div>
          </div>

          <div id="contact-status" style="margin-top: 12px; padding: 8px; background: #ffffff; border: 2px inset var(--win95-dark-gray); font-size: 11px; text-align: center; display: none;"></div>
        </form>
      </div>
    `;

    document.body.appendChild(contactWindow);
    this.contactWindow = contactWindow;

    const closeBtn = contactWindow.querySelector('.win95-btn-close');
    const minimizeBtn = contactWindow.querySelector('.win95-btn-minimize');
    const cancelBtn = contactWindow.querySelector('#contact-cancel');
    const form = contactWindow.querySelector('#contact-form');
    const submitBtn = contactWindow.querySelector('#contact-submit');
    const statusDiv = contactWindow.querySelector('#contact-status');

    const closeWindow = () => {
      contactWindow.remove();
      this.contactWindow = null;
    };

    closeBtn?.addEventListener('click', closeWindow);
    minimizeBtn?.addEventListener('click', closeWindow);
    cancelBtn?.addEventListener('click', closeWindow);

    // Handle form submission with Formspree
    form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const formData = new FormData(form);

      try {
        submitBtn.disabled = true;
        statusDiv.style.display = 'block';
        statusDiv.textContent = 'Sending message...';
        statusDiv.style.color = '#000000';

        const response = await fetch('https://formspree.io/f/mpqprorl', {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json'
          }
        });

        if (response.ok) {
          statusDiv.textContent = '✓ Message sent successfully!';
          statusDiv.style.color = '#008000';
          form.reset();
          
          setTimeout(() => {
            closeWindow();
          }, 2000);
        } else {
          throw new Error('Failed to send message');
        }
        
      } catch (error) {
        statusDiv.textContent = '✗ Error sending message. Please try again.';
        statusDiv.style.color = '#ff0000';
        submitBtn.disabled = false;
      }
    });

    window.Windows95Desktop.makeDraggable(contactWindow);
    window.Windows95Desktop.centerWindow(contactWindow);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new Windows95Contact();
  });
} else {
  new Windows95Contact();
}